import type { Tour } from '../../../mocks/tours';

const getNotIncluded = (tour: Tour): string[] => {
  const inc = tour.included.map((i) => i.toLowerCase());
  const notIncluded: string[] = [];

  if (!inc.some((i) => i.includes('her şey dahil'))) {
    notIncluded.push('Öğle ve akşam yemekleri');
  }
  if (tour.category === 'yurtdisi') {
    notIncluded.push('Vize ücreti ve pasaport masrafları');
    notIncluded.push('Seyahat sigortası');
    notIncluded.push('Havalimanı transfer ücretleri');
  }
  notIncluded.push('Kişisel harcamalar');
  notIncluded.push('Opsiyonel turlar ve ekstra aktiviteler');
  if (!inc.some((i) => i.includes('konaklama') || i.includes('otel'))) {
    notIncluded.push('Konaklama');
  }
  return notIncluded;
};

export default function IncludesSection({ tour }: { tour: Tour }) {
  const notIncluded = getNotIncluded(tour);

  return (
    <div className="bg-white rounded-2xl p-7 border border-gray-100">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-9 h-9 flex items-center justify-center bg-orange-50 rounded-xl">
          <i className="ri-checkbox-circle-line text-orange-500 text-lg" />
        </div>
        <h2 className="text-lg font-bold text-gray-900">Dahil Olanlar</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Included */}
        <div>
          <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-double-line text-green-500" />
            </div>
            Dahil Olan Hizmetler
          </h3>
          <ul className="space-y-2.5">
            {tour.included.map((item) => (
              <li key={item} className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 bg-green-50 rounded-full">
                  <i className="ri-check-line text-green-500 text-xs" />
                </div>
                <span className="text-sm text-gray-700">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Not Included */}
        <div>
          <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-close-circle-line text-red-400" />
            </div>
            Dahil Olmayan Hizmetler
          </h3>
          <ul className="space-y-2.5">
            {notIncluded.map((item) => (
              <li key={item} className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 bg-red-50 rounded-full">
                  <i className="ri-close-line text-red-400 text-xs" />
                </div>
                <span className="text-sm text-gray-600">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Highlights */}
      <div className="mt-6 pt-6 border-t border-gray-100">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Öne Çıkan Noktalar</h3>
        <div className="flex flex-wrap gap-2">
          {tour.highlights.map((h) => (
            <span
              key={h}
              className="flex items-center gap-1.5 text-xs font-medium text-orange-600 bg-orange-50 px-3 py-1.5 rounded-full border border-orange-100"
            >
              <i className="ri-map-pin-line text-orange-400" />
              {h}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
